<template>
  <div>
    <a
      href="#"
      :class="{ active: event.expanded }"
      @click.prevent="event.expanded = !event.expanded"
      class="event-inner">

      <div class="event-time">
        <div class="event-start">{{ event.start }}</div>
        <div class="event-end">{{ event.end }}</div>
      </div>
      <div class="event-title-location">
        <div class="event-title">{{ event.title }}</div>
        <div class="event-location">{{ event.location }}</div>
      </div>
      <div class="event-expand">
        <div class="icon-plus"></div>
      </div>
    </a>
    <div class="event-expanded">
      <div class="event-expanded-wrapper">
        <div class="event-expanded-date-time event-expanded-section">
          <div class="icon-clock expanded-icon"></div>
          <div>
            <div>{{ event.dayWeek }}, {{ event.month }} {{ event.day }}</div>
            <div v-if="event.start">{{ event.start }} - {{ event.end }}</div>
          </div>
        </div>
        <div class="event-expanded-location event-expanded-section">
          <div class="icon-location expanded-icon"></div>
          <a
            :href="googleLink"
            target="_blank"
            rel="noopener">

            {{ event.location }}
          </a>
        </div>
        <div class="event-expanded-description event-expanded-section">
          <div class="icon-article-1 expanded-icon"></div>
          <div v-html="event.description"></div>
        </div>
        <a
          :href="calendarLink"
          class="add-to-calendar"
        >
          Add to my calendar
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["event"],

    computed: {
      googleLink() {
        if (this.event.location) {
          return "https://www.google.com/maps/search/?api=1&query="
            + this.event.location.replace(/ /g, '+');
        }
      },
      calendarLink() {
        return this.event.ics;
      }
    }
  }
</script>

<style scoped>
  .event-inner {
    align-items: center;
    color: inherit;
    display: flex;
    padding: 1rem;
    text-decoration: none;
    transition: background-color 0.15s;
  }

  .event-inner .icon-plus {
    transition: transform 0.25s;
  }

  .event-inner.active {
    background-color: #4097CC;
    color: #fff;
    transition: all 0.15s;
  }

  .event-inner.active .event-time {
    color: #fff;
  }

  .event-inner.active + .event-expanded {
    display: block;
    opacity: 1;
  }

  .event-inner.active .event-expand {
    border-color: #fff;
    color: #fff;
  }

  .event-inner.active .icon-plus {
    transform: rotate(225deg);
    transition: transform 0.25s;
  }

  .event-time {
    color: #75988D;
    flex-basis: 25%;
  }

  .event-start {
    font-weight: 700;
  }

  .event-title-location {
    flex-basis: 75%;
    padding-right: 3rem;
  }

  .event-title {
    font-weight: 700;
  }

  .event-expanded {
    display: none;
    opacity: 0;
    transition: background-color 0.15s;
  }

  .event-expanded-wrapper {
    background-color: #f4f4f4;
    padding: 1rem;
  }

  .event-expand {
    border: 1px solid;
    border-radius: 50%;
    color: #ABB7C4;
    font-size: 2rem;
    padding: 1px 0;
  }

  .event-expanded-section {
    display: flex;
    padding-bottom: 2rem;
  }

  .expanded-icon {
    color: #8a8a8a;
    font-size: 3rem;
    padding-right: 1rem;
  }

  .add-to-calendar {
    background-color: #4097CC;
    color: #fff;
    display: block;
    font-size: 3rem;
    margin: 2rem 5rem;
    padding: 1rem;
    text-align: center;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Event.vue